import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { concatMap, delay, map, switchMap } from 'rxjs/operators';
import { AlertsConfig } from '../../config/alerts-config';
import { AlertsActionTypes } from '../actions/alerts.action';
import { AlertsActions } from '../actions/index';

@Injectable()
export class AlertsEffects {
  clearAlertDismissalAfterDelay$: Observable<AlertsActions.ClearAlert> = createEffect(() =>
    this.actions$.pipe(
      ofType(AlertsActionTypes.ClearAlertDelayed),
      map((action: AlertsActions.ClearAlertDelayed) => action.payload),
      concatMap((payload) => {
        return of(payload).pipe(
          delay(this.config.alerts.reappearTime * 1000),
          switchMap(() => of(new AlertsActions.ClearAlert({ ...payload })))
        );
      })
    )
  );

  constructor(private actions$: Actions, private config: AlertsConfig) {}
}
